/**
 * Filename: home.js
 * Home page
 * Component path
 * IconBoxed  'componenet/iconboxes.js'
 * Charts compoenent from 'compoenent/charts'
 * Table from 'containers/table.js'
 */

import React, {Component} from 'react';
import SidebarMenuRouters from "../../routers/routers.js";
import Header from '../../containers/header.js';
import ActionTools from '../../containers/actionTools.js';
import {Redirect} from 'react-router';
import {ROL} from '../../utils/constants';

class DirectionHome extends Component {
  constructor(props) {
    super(props);
    var userData = JSON.parse(localStorage.getItem("userData"));
    this.state = {userData: userData};
  }

  render() {
    var result;
    if (this.state.userData.rol === ROL.DIRECTION.url) {
      result = <div>
        <SidebarMenuRouters profile="/direction-home/" place={this.props.match.params.vp} kpis={this.props.location.state}/>
        <Header userName={this.state.userData.name}/>
        {/*<div className="vl"></div>*/}
        <ActionTools profile={'/profile-direction/place/'} place={this.props.match.params.vp} kpis={this.props.location.state}/>
      </div>
    } else {
      result = <Redirect to={"/"}/>
    }
    return (
      <div>
        {result}
      </div>
    );
  }
}

export default DirectionHome;



// WEBPACK FOOTER //
// ./src/scene/direction/home.js